import Layout from '../../components/Layout/Layout.component';
import Breadcrumbs from '../../components/Breadcrumbs.component';
import { Paths } from '../../utils/routerUrls';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { MovieWatch } from '../../components/SupportMovie/MovieWatch/MovieWatch.component';
import { useParams } from 'react-router-dom';
import { useStyles } from './SupportMovieWatch.styles';
import { useEffect, useState } from 'react';
import { IMovieItem } from '../../services/supportMovie/supportMovie.types';
import { getMovie } from '../../services/supportMovie/supportMovie.service';
import usePermission, { UserPermission } from '../../hooks/usePermission';
import { useLayoutContext } from '../../Context/Layout.context';
import { shortenText } from '../../utils/textHelper';

export const SupportMovieWatch: React.FC = () => {
  const classes = useStyles();
  const isAdminPermission = usePermission(UserPermission.AdminSupportManage);
  const { t } = useTranslation();
  const { openAlert } = useLayoutContext();

  useDocumentTitle("Materiały wideo");

  const { movieId } = useParams() as {
    movieId: string;
  };

  const [movie, setMovie] = useState<IMovieItem | undefined>();

  useEffect(() => {
    getMovie(movieId).then(
      (response) => {
        if (response.status) {
          setMovie(response.data);
        } else {
          openAlert('get_error');
        }
      },
      () => openAlert('get_error'),
    );
  }, [movieId]);

  return (
    <Layout viewType={isAdminPermission ? 'admin' : 'fullwidthForExaminer'}>
      <div className={classes.container}>
        <div>
          <Breadcrumbs
            listRoute={Paths.supportMovies}
            currentList="Materiały wideo"
            currentElement={shortenText(movie?.title, 50)}
            mainElementRoute={Paths.support}
            mainElement={`Centrum pomocy ${t('global:shortNames.beneficiary')} ${t('global:shortNames.system')}`}
          />
        </div>
        <div className={classes.nameDiv} style={{ textAlign: 'center' }}>
          <h3>{movie?.title}</h3>
        </div>
        <MovieWatch movie={movie}></MovieWatch>
      </div>
    </Layout>
  );
};
